import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { translate, Trans } from 'react-i18next';
import Panel from '../layout/Panel';
import { Icon } from '../icons';
import Button from '../layout/Button';
import BrightnessGraph from '../profiles/BrightnessGraph';

const Show = ({t, organisationId, event, eventId, scheduleId, history, devices }) => {
  const schedule = event.schedules.find(s => s.id === scheduleId);
  const count = schedule.device_addresses.length;
  return (
    <Panel
      onCloseClick={() => history.push(`/organisations/${organisationId}/events/${eventId}/schedules${location.search}`)}
      title={schedule.description}>
      <div className="device-selection">
        <div className="profile-chart">
          {event.status === "created" && (
            <div className="btn-container">
              <Link className="profile-edit" to={`/organisations/${organisationId}/events/${eventId}/schedules/${scheduleId}/edit${location.search}`}><Icon className="profile-edit-icon" type={'pencil'} /></Link>
            </div>
          )}
          <BrightnessGraph brightness={schedule.settings} />
        </div>
        <div className="text-break">
          <Trans i18nKey="SCHEDULE_COUNT" count={count}>
            This schedule is used by {{ count }} devices
          </Trans>
        </div>
        <div className="devices-list">
          {event.status === "created" && <Link className="btn add-devices-btn" to={`/organisations/${organisationId}/events/${eventId}/schedules/${scheduleId}/devices${location.search}`}>+</Link>}
          <ul>
            {schedule.device_addresses.map(d_addr =>
              <li key={d_addr}>
                <div className="device-icon">
                  <Icon type={'circle'} />
                </div>
                <div className="device-name">
                  {devices.data.find(d => d.uid === d_addr).name}
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    </Panel>
  );
}

export default translate('profile')(withRouter(connect(
  ( { events, devices }, { match: { params: { organisationId, eventId, scheduleId } }, location, history }) => ({
    organisationId,
    eventId,
    scheduleId,
    location,
    history,
    event: events.data.find(e => e.id === eventId),
    devices
  })
)(Show)));



// WEBPACK FOOTER //
// ./src/components/schedules/Show.js